import { Anchor, Group, Image } from "@mantine/core";

interface SupportAttachmentsProps {
  urls?: string[];
  size?: number;
}

// Thumbnails that open the full image in a new tab. Kept deliberately plain;
// a lightbox can come later if tickets start carrying many images.
const SupportAttachments = ({ urls, size = 72 }: SupportAttachmentsProps) => {
  if (!urls || urls.length === 0) return null;
  return (
    <Group gap="xs" mt="xs">
      {urls.map((url) => (
        <Anchor key={url} href={url} target="_blank" rel="noreferrer">
          <Image
            src={url}
            alt="Attachment"
            w={size}
            h={size}
            fit="cover"
            radius="sm"
            style={{ border: "1px solid var(--mantine-color-default-border)" }}
          />
        </Anchor>
      ))}
    </Group>
  );
};

export default SupportAttachments;
